/* Ground Central — open the header mega menu on hover.
   Desktop, hover-capable pointers only. Dawn's <header-menu>/<details> keeps
   handling click, keyboard, focus-out, Escape and the sticky-header close;
   this adds the pointer behaviour and keeps the panel inside the viewport. */
(function () {
  if (window.gcMegaMenuReady) return;
  window.gcMegaMenuReady = true;

  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var CLOSE_DELAY = 160; // ms of grace when the pointer leaves (gap crossing, diagonal moves)
  var EDGE = 24; // px to keep between the panel and the viewport's right edge

  function setup(menu) {
    var details = menu.querySelector('details.gc-mega');
    if (!details) return;
    var summary = details.querySelector('summary');
    var panel = details.querySelector('.gc-mega__panel');
    var timer = null;

    function fit() {
      if (!panel || !details.open) return;
      panel.style.removeProperty('--gc-mega-shift');
      var over = panel.getBoundingClientRect().right - (window.innerWidth - EDGE);
      if (over > 0) panel.style.setProperty('--gc-mega-shift', -Math.ceil(over) + 'px');
    }

    function open() {
      clearTimeout(timer);
      if (!mq.matches || details.open) return;
      document.querySelectorAll('header-menu details[open]').forEach(function (other) {
        if (other === details) return;
        other.removeAttribute('open');
        var s = other.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      });
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(fit);
    }

    function close() {
      clearTimeout(timer);
      if (!details.open) return;
      details.removeAttribute('open');
      summary.setAttribute('aria-expanded', 'false');
    }

    function scheduleClose() {
      clearTimeout(timer);
      timer = setTimeout(close, CLOSE_DELAY);
    }

    menu.addEventListener('mouseenter', open);
    menu.addEventListener('mouseleave', scheduleClose);

    // With the panel already open on hover, a mouse click on the item follows
    // its own link instead of collapsing the panel. Keyboard activation
    // (event.detail === 0) keeps the native open/close toggle.
    summary.addEventListener('click', function (event) {
      if (!mq.matches || event.detail === 0) return;
      var url = summary.getAttribute('data-url');
      if (details.open && url) {
        event.preventDefault();
        window.location.href = url;
      }
    });

    details.addEventListener('toggle', function () {
      if (details.open) requestAnimationFrame(fit);
    });
    window.addEventListener('resize', fit);
  }

  function init() {
    document.querySelectorAll('header-menu').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
